import { forwardRef, Ref, SVGProps } from 'react';

export interface IconWrapperProps extends SVGProps<SVGSVGElement> {
  ref?: Ref<SVGSVGElement>;
}

export const IconWrapper = forwardRef<SVGSVGElement, IconWrapperProps>(
  ({ width = 10, height = 10, className, children, ...props }, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      ref={ref}
      {...props}
    >
      {children}
    </svg>
  ),
);

export default IconWrapper;
